export const MOVE_STAGE_BULK_BUTTON_SX = {
  textTransform: "none",
  fontFamily: "Be Vietnam Pro",
  fontWeight: 500,
  fontSize: 13,
  borderRadius: 30,
  px: 2.5,
  py: 0.75,
  minWidth: 90,
  minHeight: 40,
  border: "1px solid transparent",
  color: "#FFFFFF",
  backgroundColor: "#9C4FFF",
  boxShadow: "none",
  justifyContent: "flex-start",
  "& .MuiButton-startIcon, & .MuiButton-endIcon": {
    color: "inherit",
  },
  "& .MuiButton-startIcon": {
    mr: 0.5,
    ml: 0,
  },
  "&:hover": {
    backgroundColor: "#8B3DFF",
    borderColor: "#8B3DFF",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    color: "#A2ABB4",
    borderColor: "#A2ABB4",
    backgroundColor: "transparent",
    boxShadow: "none",
    opacity: 1,
  },
};
